export default function Dates() {
	return (
		<main>
			<div className="relative isolate overflow-hidden bg-stone-900">
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[-22rem] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] xl:ml-0 xl:mr-[calc(50%-12rem)]"
					>
						<use href="#bc169a03-3518-42d4-ab1e-d3eadac65edc" />
					</svg>
				</div>
				<div className="px-6 pt-32 sm:px-8">
					<div className="mx-auto max-w-2xl text-center sm:pt-12">
						<h2 className="text-4xl font-bold tracking-tight text-white sm:text-6xl">
							Hours & Dates
						</h2>
					</div>
				</div>
				<div className="mx-auto my-12 max-w-7xl px-6 lg:px-8">
					<div className="mx-auto mb-8 max-w-2xl lg:mx-0">
						<h2 className="text-2xl font-bold tracking-tight text-[#f9c04d] sm:text-3xl">
							Studio Hours
						</h2>
					</div>
					<div className="grid max-w-2xl grid-cols-2 gap-8 text-sm leading-7 sm:grid-cols-2 sm:gap-y-16 sm:text-base lg:mx-0 lg:max-w-none lg:grid-cols-4">
						<div>
							<h3 className="border-l border-[#f9c04d] pl-6 font-semibold text-white">
								Monday
							</h3>
							<div className="border-l border-stone-200 pl-6 pt-2 not-italic text-stone-200">
								<p>3:30pm - 9:00pm</p>
							</div>
						</div>
						<div>
							<h3 className="border-l border-[#f9c04d] pl-6 font-semibold text-white">
								Tuesday
							</h3>
							<div className="border-l border-stone-200 pl-6 pt-2 not-italic text-stone-200">
								<p>9:30am - 11:45am</p>
							</div>
							<div className="border-l border-stone-200 pl-6 pt-2 not-italic text-stone-200">
								<p>4:00pm - 9:30pm</p>
							</div>
						</div>
						<div>
							<h3 className="border-l border-[#f9c04d] pl-6 font-semibold text-white">
								Wednesday
							</h3>
							<div className="border-l border-stone-200 pl-6 pt-2 not-italic text-stone-200">
								<p>8:45am - 11:00am</p>
							</div>
							<div className="border-l border-stone-200 pl-6 pt-2 not-italic text-stone-200">
								<p>4:00pm - 10:00pm</p>
							</div>
						</div>
						<div>
							<h3 className="border-l border-[#f9c04d] pl-6 font-semibold text-white">
								Thursday
							</h3>
							<div className="border-l border-stone-200 pl-6 pt-2 not-italic text-stone-200">
								<p>4:00pm - 9:45pm</p>
							</div>
						</div>
						<div>
							<h3 className="border-l border-[#f9c04d] pl-6 font-semibold text-white">
								Friday
							</h3>
							<div className="border-l border-stone-200 pl-6 pt-2 not-italic text-stone-200">
								<p>10:15am - 12:30pm</p>
							</div>
							<div className="border-l border-stone-200 pl-6 pt-2 not-italic text-stone-200">
								<p>4:00pm - 8:00pm</p>
							</div>
						</div>
						<div>
							<h3 className="border-l border-[#f9c04d] pl-6 font-semibold text-white">
								Saturday
							</h3>
							<div className="border-l border-stone-200 pl-6 pt-2 not-italic text-stone-200">
								<p>8:45am - 2:00pm</p>
							</div>
						</div>
						<div>
							<h3 className="border-l border-[#f9c04d] pl-6 font-semibold text-white">
								Sunday
							</h3>
							<div className="border-l border-stone-200 pl-6 pt-2 not-italic text-stone-200">
								<p>CLOSED</p>
							</div>
						</div>
					</div>
				</div>
				<div className="mx-auto my-20 max-w-7xl space-y-12 px-6 lg:px-8 xl:flex xl:gap-x-24 xl:space-y-0">
					<div className="">
						<div className="mx-auto max-w-2xl sm:mb-8 lg:mx-0">
							<h2 className="text-2xl font-bold tracking-tight text-[#f9c04d] sm:text-3xl">
								Closing / Important Dates
							</h2>
						</div>
						<section className="sm:mt-8">
							<ol className="mt-2 divide-y divide-stone-300 text-sm leading-6 text-stone-100 sm:text-base">
								<li className="py-4 sm:flex">
									<time
										dateTime="2026-09-08"
										className="w-72 flex-none font-bold"
									>
										Sept 8, 2026
									</time>
									<p className="mt-2 flex-auto sm:mt-0">First day of classes</p>
								</li>
								<li className="py-4 sm:flex">
									<time
										dateTime="2026-11-24"
										className="w-72 flex-none font-bold"
									>
										Nov 24 - 28, 2026
									</time>
									<p className="mt-2 flex-auto sm:mt-0">Fall Break - Closed</p>
								</li>
								<li className="py-4 sm:flex">
									<time
										dateTime="2026-12-20"
										className="w-72 flex-none font-bold"
									>
										Dec 20, 2026 - Jan 3, 2027
									</time>
									<p className="mt-2 flex-auto sm:mt-0">
										Winter Break - Closed
									</p>
								</li>
								<li className="py-4 sm:flex">
									<time
										dateTime="2026-12-21"
										className="w-72 flex-none font-bold"
									>
										Dec 21, 2026
									</time>
									<p className="mt-2 flex-auto sm:mt-0">
										Tentative - Christmas Spectacular Dress Rehearsal
									</p>
								</li>
								<li className="py-4 sm:flex">
									<time
										dateTime="2026-12-22"
										className="w-72 flex-none font-bold"
									>
										Dec 22, 2026
									</time>
									<p className="mt-2 flex-auto sm:mt-0">
										Tentative - Christmas Spectacular Show Day
									</p>
								</li>
								<li className="py-4 sm:flex">
									<time
										dateTime="2027-03-21"
										className="w-72 flex-none font-bold"
									>
										Mar 21 - 28, 2027
									</time>
									<p className="mt-2 flex-auto sm:mt-0">Spring Break</p>
								</li>
								<li className="py-4 sm:flex">
									<time
										dateTime="2027-06-03"
										className="w-72 flex-none font-bold"
									>
										Jun 3, 2027
									</time>
									<p className="mt-2 flex-auto sm:mt-0">
										Tentative - 35th Annual Production Dress Rehearsal
									</p>
								</li>
								<li className="py-4 sm:flex">
									<time
										dateTime="2027-06-06"
										className="w-72 flex-none font-bold"
									>
										Jun 6, 2027
									</time>
									<p className="mt-2 flex-auto sm:mt-0">
										Tentative - 35th Annual Production Show Day
									</p>
								</li>
							</ol>
						</section>
					</div>
					<div className="">
						<div className="mx-auto max-w-2xl sm:mb-8 lg:mx-0">
							<h2 className="text-2xl font-bold tracking-tight text-[#f9c04d] sm:text-3xl">
								7 Week Sessions
							</h2>
						</div>
						<section className="sm:mt-8">
							<ol className="mt-2 divide-y divide-stone-300 text-sm leading-6 text-stone-100 sm:text-base">
								<li className="py-4 sm:flex">
									<time
										dateTime="2026-09-08"
										className="w-72 flex-none font-bold"
									>
										Sept 8 - Oct 26, 2026
									</time>
									<p className="mt-2 flex-auto sm:mt-0">Session 1</p>
								</li>
								<li className="py-4 sm:flex">
									<time
										dateTime="2026-10-27"
										className="w-72 flex-none font-bold"
									>
										Oct 27 - Dec 19, 2026
									</time>
									<p className="mt-2 flex-auto sm:mt-0">Session 2</p>
								</li>
								<li className="py-4 sm:flex">
									<time
										dateTime="2027-01-04"
										className="w-72 flex-none font-bold"
									>
										Jan 4 - Feb 20, 2027
									</time>
									<p className="mt-2 flex-auto sm:mt-0">Session 3</p>
								</li>
								<li className="py-4 sm:flex">
									<time
										dateTime="2027-02-22"
										className="w-72 flex-none font-bold"
									>
										Feb 22 - Apr 17, 2027
									</time>
									<p className="mt-2 flex-auto sm:mt-0">Session 4</p>
								</li>
								<li className="py-4 sm:flex">
									<time
										dateTime="2027-04-19"
										className="w-72 flex-none font-bold"
									>
										Apr 19 - May 29, 2027
									</time>
									<p className="mt-2 flex-auto sm:mt-0">Session 5</p>
								</li>
							</ol>
						</section>
					</div>
				</div>
			</div>
		</main>
	)
}
